import { useNavigate } from "react-router";

import { css } from "@emotion/react";

import { CloseIcon, colors } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import Logo from "components/Logo";
import { handleLogoClick } from "components/Navbar/functions";
import { CONTROLS_ITEM_FRAME_CLOSE_BUTTON } from "components/TutorialMode/constants";
import { useMediaQueries, useWindowLocation } from "shared";

import { ControlsItemFrameProps } from "./types";

const ControlsItemFrame = ({
    close,
    boxPadding,
    itemName,
    hasBottomBorder
}: ControlsItemFrameProps) => {
    const { gray200, gray900 } = colors;

    const { toMd, fromMd } = useMediaQueries();
    const { pathname } = useWindowLocation();
    const navigate = useNavigate();

    return (
        <>
            {toMd && (
                <div
                    css={css({
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "16px 0 4px 24px"
                    })}
                >
                    <Logo
                        css={css({
                            cursor: "pointer"
                        })}
                        onClick={() => {
                            handleLogoClick(pathname, navigate);
                            close();
                        }}
                    />
                </div>
            )}

            <div
                css={css({
                    position: "relative",
                    display: "flex",
                    justifyContent: "space-between",
                    padding: boxPadding,
                    borderBottom: hasBottomBorder
                        ? `1px solid ${gray200}`
                        : "none",

                    "& > h2": {
                        color: gray900,
                        fontSize: "20px",
                        lineHeight: "24px",
                        fontWeight: "500",
                        letterSpacing: "0.15px",
                        alignSelf: "flex-end"
                    },

                    "& > button": {
                        position: "absolute",
                        top: "4px",
                        right: "4px"
                    }
                })}
            >
                <h2>{itemName}</h2>

                {fromMd && (
                    <Button
                        id={CONTROLS_ITEM_FRAME_CLOSE_BUTTON}
                        color={BUTTON_COLORS.White}
                        size={BUTTON_SIZES.Small}
                        variant={BUTTON_VARIANTS.IconOnly}
                        icon={<CloseIcon />}
                        onClick={close}
                    />
                )}
            </div>
        </>
    );
};

export default ControlsItemFrame;
